export default {"src":"/_next/static/media/signout.2564af09.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};